import { ButtonModule, CoreModule, FormFieldModule, IconModule, InputModule } from '@activia/ngx-components';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { LoginComponent } from './login.component';
import { TranslocoModule } from '@ngneat/transloco';

export const routes = [{ path: '', component: LoginComponent, pathMatch: 'full' }];

@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, TranslocoModule, FormsModule, RouterModule.forChild(routes), ReactiveFormsModule, CoreModule, ButtonModule, IconModule, FormFieldModule, InputModule],
})
export class LoginModule {
  public static routes = routes;
}
